<template>
  <div class="pins">
    <div class="pins__price">
      {{
        getTranslation(276, {
          PRICE: formatPrice(vehicle.motors[0].price),
          CURRENCY: currency,
        })
      }}
    </div>
    <div class="pins__installment">
      {{ formatPrice(vehicle.motors[0].installment) }}{{ currency }} /
      {{ getTranslation(285).toLowerCase() }}
    </div>
    <div class="pins__rent">
      {{
        getTranslation(284, {
          AMOUNT: formatPrice(vehicle.motors[0].first_payment),
          CURRENCY: currency,
        })
      }}
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { priceManager } from "@/services/price-manager";
import { useMainStore } from "@/store";
import { getTranslation } from "@/services/translation-manager";

export default {
  name: "PinsComponent",
  computed: {
    ...mapState(useMainStore, {
      vehicle: (store) => store.vehicle,
      currency: (store) => store.currency,
    }),
  },
  methods: {
    getTranslation,
    formatPrice(price) {
      return priceManager.format(price);
    },
  },
};
</script>

<style lang="scss" scoped>
.pins {
  position: absolute;
  right: 40px;
  top: 0;
  padding: 50px 22.5px;
  color: $white;
  font-size: 16px;

  &:before {
    content: "";
    position: absolute;
    top: -50%;
    left: 0;
    height: 150%;
    width: 100%;
    background: $blue;
    z-index: -1;
    transform: skewY(- calc($skew/3));
  }

  &__price {
    font-size: 20px;
    line-height: 1.9;
  }

  &__installment {
    font-size: 35px;
    font-weight: 700;
    line-height: 0.9;
    margin-bottom: 5px;
  }
}
</style>
